var _defs, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.407 2a2.407 2.407 0 1 0 0 4.814 2.407 2.407 0 0 0 0-4.814zm12.648 6.39c-2.008 0-3.343 1.1-3.895 2.144h-.088V8.696H9.133V22h4.114v-6.565c0-1.734.345-3.413 2.495-3.413 2.117 0 2.144 1.958 2.144 3.501V22H22v-7.309c0-3.577-.76-6.302-4.945-6.302zm-14.661.306V22H6.55V8.696H2.394z",
    id: "linkedin-a"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    fillRule: "nonzero",
    xlinkHref: "#linkedin-a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.af6028142172878fa452e3a8e49c9107.svg";
export { ForwardRef as ReactComponent };